import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTheme } from '@components/settings/actions';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui';
import VisuallyHiddenLegend from '@shared/visually-hidden-legend';
import UnstyledHeading from '@shared/unstyled-heading';
import './settings.scss';

const Theme = () => {
  const { global: { theme, available_themes: availableThemes } } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const onChange = event => dispatch(updateTheme(event.target.value));

  return (
    <div styleName="settings-form-container">
      <div styleName="title">
        <UnstyledHeading rank={2}>
          <div styleName="text">Theme</div>
        </UnstyledHeading>
      </div>
      <div styleName="hint">
        Switch between the available color and style themes.
      </div>
      <div styleName="form">
        <FormControl component="fieldset">
          <VisuallyHiddenLegend>Theme</VisuallyHiddenLegend>
          <RadioGroup aria-label="theme" name="theme" value={theme} onChange={onChange}>
            {availableThemes.map(({ value, label }) => (
              <FormControlLabel key={value} value={value} control={<Radio color="primary" />} label={label} />
            ))}
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};

export default memo(Theme);
